<template>
  <div>
    <Modal
      footer-hide
      v-model="Modal"
      width="80%">
      <Spin fix v-show="getting">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      </Spin>
      <p slot="header">
        <Icon type="ios-text" />
        <span> 未同步监控用户列表</span>
      </p>
      <div v-if="error">
        <Alert show-icon type="error">{{ errorText }}</Alert>
      </div>
      <div v-else-if="!data.length">
        <Alert show-icon type="success">所有用户已同步</Alert>
      </div>
      <div v-else>
        <Row style="margin-bottom: 10px">
          <Button type="primary" icon="md-sync" style="float: right" :loading="syncing" @click="sync">立即同步</Button>
        </Row>
        <GeminiScrollbar class="logs-scroll-bar" >
          <Table name="Table" border :columns="columns" size="small" :data="data"></Table>
        </GeminiScrollbar>
      </div>
    </Modal>
  </div>
</template>

<script>
import { monitorUserSync, unSyncMonitorUserList } from '@/api/monitor'

export default {
  name: 'un-sync-monitor-user-modal',
  data () {
    return {
      errorText: '',
      error: false,
      Modal: false,
      columns: [
        {title: '用户名', key: 'username', align: 'center', minWidth: 200},
        {title: '姓名', key: 'name', align: 'center', minWidth: 90},
        {title: '手机', key: 'mobile', align: 'center', minWidth: 100},
        {title: '邮箱', key: 'email', align: 'center', minWidth: 200},
        {
          title: '激活',
          key: 'is_active',
          align: 'center',
          minWidth: 90,
          render: (h, params) => {
            if (params.row.is_active) {
              return h('Tag', {
                attrs: {
                  color: 'success'
                }
              }, '是')
            } else {
              return h('Tag', {
              }, '否')
            }
          }
        },
        {
          title: '超级管理员',
          key: 'is_superuser',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.is_superuser) {
              return h('Tag', {
                attrs: {
                  color: 'success'
                }
              }, '是')
            } else {
              return h('Tag', {
              }, '否')
            }
          }
        }
      ],
      data: [],
      getting: false,
      syncing: false
    }
  },
  created: function () {
    this.openModalFun()
  },
  methods: {
    // 获取未同步用户
    getData () {
      this.getting = true
      unSyncMonitorUserList().then(res => {
        this.getting = false
        let result = res.data
        if (result.code === 200) {
          this.data = result.data
          this.error = false
        } else {
          this.errorText = result.msg
          this.error = true
        }
      }).catch(res => {
        this.errorText = '获取失败, 请检查服务'
        this.error = true
        this.getting = false
      })
    },
    // 开始同步
    sync () {
      this.syncing = true
      monitorUserSync().then(res => {
        this.syncing = false
        let result = res.data
        if (result.code === 200) {
          this.getData()
          this.$Notice.success({ title: '操作成功' })
        }
      }).catch(res => {
        this.syncing = false
        this.$Notice.error({ title: '操作失败, 请检查服务' })
      })
    },
    openModal () {
      this.Modal = true
      this.getData()
    },
    // 组件可调用函数 - 触发打开Modal
    openModalFun () {
      eventVue.$on('openSyncUserModalFun', () => {
        this.openModal()
      })
    }
  }
}
</script>

<style scoped>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
